import { FtuImportSuccessStepBody } from './ftu-import-success-step';
import { FtuOrderConfigStepBody } from './ftu-order-config-step-body';
import { messages } from './messages';
import { StepType } from '../../../../../../components/csv-import/data/types/step-type';
import { CreateMappingStepBody } from '../../../../../../components/csv-import/ui/components/steps/create-mapping-step/create-mapping-step';

export const ftuOrderImportSteps = [
  {
    id: StepType.CREATE_CONFIG,
    title: messages.uploadFileStepText,
    body: <FtuOrderConfigStepBody />,
  },
  {
    id: StepType.CREATE_MAPPING,
    title: messages.matchFieldsStepText,
    body: <CreateMappingStepBody />,
  },
  {
    id: StepType.IMPORT_IS_PROCESSING,
    title: messages.importProcessingStepText,
    body: <FtuImportSuccessStepBody />,
  },
];
